import React from 'react'
import Mainlayout from '../layout/Mainlayout'
import Users from '../data/Users.json'


export default function Allusers() {

    
    return (
        <Mainlayout>
            <div className='bg-dwam p-2 flex-col md:justify-evenly flex md:flex-row-reverse flex-wrap'>
                {Users.map((user) => {
                    return (
                        <>
                            <div className='bg-yakam w-full flex flex-row-reverse md:w-[45%] rounded-3xl my-2 mx-2'>
                                <img className='rounded-r-3xl w-32 h-32 md:w-48 md:h-48' src={user.userImage} alt={user.userImage} />
                                <div className='rounded-l-3xl text-right text-xs md:text-lg md:p-5 p-3 bg-penjam text-yakam w-full'>
                                    <div>
                                        <div className='flex flex-wrap flex-row-reverse'>
                                            <p> : ناو</p>
                                            <h1>&nbsp;{user.userName}&nbsp;</h1>
                                        </div>
                                        <div className='flex flex-wrap flex-row-reverse'>
                                            <p> : هەژماری ئەلئکترۆنی</p>
                                            <p>&nbsp;{user.email}&nbsp;</p>
                                        </div>
                                        <div className='flex flex-wrap flex-row-reverse'>
                                            <p>: ڕۆڵ</p>
                                            <p>&nbsp;{user.userRole}&nbsp;</p>
                                            <div className='flex w-full flex-row items-center justify-end space-x-2 '>
                                                <p className='text-xs md:text-lg text-shasham underline cursor-pointer hover:text-chwaram'>بیکەبە ئەدمین</p>
                                                <p className='text-xs md:text-lg text-shasham underline cursor-pointer hover:text-chwaram'>بیکەبە یوزەری ئاسای</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </>
                    )
                })}
            </div>
        </Mainlayout>
    )
}
